// <s-sticky-buy-bar> slides a compact purchase bar in once the main add-to-cart
// button scrolls out of view. Its button submits the main product form (via the
// form attribute), so the selected variant and quantity always match the page.
class SStickyBuyBar extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.getElementById(this.dataset.watch || '');
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.toggleAttribute('data-visible', passed);
        this.setAttribute('aria-hidden', passed ? 'false' : 'true');
        this.inert = !passed;
      },
      { threshold: 0 }
    );
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-buy-bar')) {
  customElements.define('s-sticky-buy-bar', SStickyBuyBar);
}
